import {
  FileText, TrendingUp, DollarSign,
  Clock, Users, Activity, PieChart
} from "lucide-react";

export const getCategories = (text, language) => [
  { id: "all", name: text[language].allReports, icon: FileText, color: "#6366f1", description: text[language].allReportsDesc },
  { id: "performance", name: text[language].performance, icon: TrendingUp, color: "#10b981", description: text[language].performanceDesc },
  { id: "payroll", name: text[language].payroll, icon: DollarSign, color: "#f59e0b", description: text[language].payrollDesc },
  { id: "attendance", name: text[language].attendance, icon: Clock, color: "#ef4444", description: text[language].attendanceDesc },
  { id: "recruitment", name: text[language].recruitment, icon: Users, color: "#8b5cf6", description: text[language].recruitmentDesc },
  { id: "training", name: text[language].training, icon: Activity, color: "#06b6d4", description: text[language].trainingDesc },
  { id: "budget", name: text[language].budget, icon: PieChart, color: "#84cc16", description: text[language].budgetDesc },
];